import { Menu, X } from "lucide-react";
import { NavLinks } from "./NavLinks";

interface MobileMenuProps {
  isOpen: boolean;
  onToggle: () => void;
  transparent?: boolean;
}

export const MobileMenu = ({
  isOpen,
  onToggle,
  transparent = false,
}: MobileMenuProps) => {
  return (
    <>
      <button
        className={`md:hidden p-3 -m-1 rounded-xl hover:bg-muted/50 transition-colors min-w-[48px] min-h-[48px] flex items-center justify-center ${transparent ? "text-white hover:bg-white/10" : ""}`}
        onClick={onToggle}
        aria-label="Toggle menu"
      >
        {isOpen ? (
          <X className="h-6 w-6" />
        ) : (
          <Menu className="h-6 w-6" />
        )}
      </button>

      {isOpen && (
        <div className="md:hidden absolute left-3 right-3 sm:left-6 sm:right-6 lg:left-8 lg:right-8 top-full mt-2 rounded-2xl bg-background/95 backdrop-blur-md border border-border shadow-lg animate-fade-in z-50">
          <NavLinks variant="mobile" onItemClick={onToggle} />
        </div>
      )}
    </>
  );
};
